<template>
    <div class="oss-management-page">
      <div class="settings-card">
        <h2 class="page-title">
          <Icon icon="heroicons:folder" width="24" height="24" />
          阿里云OSS配置
        </h2>
        <el-form :model="ossForm" label-width="140px" class="compact-form">
          <!-- AccessKey ID -->
          <el-form-item label="阿里云ID：" class="form-item-row">
            <el-input v-model="ossForm.aliyun_keyid" placeholder="请输入阿里云AccessKey ID" size="large" show-password
              clearable class="oss-input">
              <template #prefix>
                <Icon icon="heroicons:key" width="18" height="18" />
              </template>
            </el-input>
          </el-form-item>
  
          <!-- AccessKey Secret -->
          <el-form-item label="Secret：" class="form-item-row">
            <el-input v-model="ossForm.aliyun_secret" placeholder="请输入阿里云AccessKey Secret" size="large"
              show-password clearable class="oss-input">
              <template #prefix>
                <Icon icon="heroicons:lock-closed" width="18" height="18" />
              </template>
            </el-input>
          </el-form-item>
  
          <!-- Endpoint -->
          <el-form-item label="存储地域：" class="form-item-row">
            <el-input v-model="ossForm.endpoint" placeholder="例如：oss-cn-hangzhou.aliyuncs.com" size="large"
              clearable class="oss-input">
              <template #prefix>
                <Icon icon="heroicons:map-pin" width="18" height="18" />
              </template>
            </el-input>
            <div class="oss-tip">
              <Icon icon="heroicons:information-circle" width="14" height="14" class="tip-icon" />
              <span>请填写Bucket所在区域的外网Endpoint</span>
            </div>
          </el-form-item>
  
          <!-- Bucket名称 -->
          <el-form-item label="Bucket：" class="form-item-row">
            <el-input v-model="ossForm.aliyun_bucket" placeholder="请输入Bucket名称" size="large" clearable
              class="oss-input">
              <template #prefix>
                <Icon icon="heroicons:archive-box" width="18" height="18" />
              </template>
            </el-input>
          </el-form-item>
  
          <!-- 测试连接 -->
          <el-form-item label="连接测试：" class="form-item-row">
            <el-button type="info" size="large" class="test-btn" @click="testConnection" :loading="testing">
              <Icon icon="heroicons:signal" width="18" height="18" class="btn-icon" />
              测试OSS连接
            </el-button>
            <div class="test-result" v-if="testResult !== null">
              <el-tag :type="testResult ? 'success' : 'danger'" size="large">
                {{ testResult ? '连接成功' : '连接失败' }}
              </el-tag>
              <span class="result-message" v-if="testMessage">{{ testMessage }}</span>
            </div>
          </el-form-item>
  
          <!-- 操作按钮 -->
          <el-form-item class="form-actions">
            <el-button type="primary" size="large" class="submit-btn" @click="submitOssConfig" :loading="loading">
              <Icon icon="heroicons:check" width="18" height="18" class="btn-icon" />
              保存配置
            </el-button>
            <el-button type="info" size="large" class="reset-btn" @click="resetOssConfig">
              <Icon icon="heroicons:arrow-path" width="18" height="18" class="btn-icon" />
              重置表单
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </template>
  
  <script>
  import axios from 'axios';
  import config from '@/config.js';
  import Cookies from 'js-cookie';
  import { Icon } from '@iconify/vue';
  import { ElMessage, ElMessageBox } from 'element-plus';
  
  export default {
    name: 'SystemOssConfig',
    components: { Icon },
    data() {
      return {
        loading: false,
        testing: false,
        testResult: null,
        testMessage: '',
        ossForm: {
          aliyun_keyid: '',
          aliyun_secret: '',
          endpoint: '',
          aliyun_bucket: ''
        }
      }
    },
    computed: {
      userInfo() {
        return JSON.parse(Cookies.get('user_info') || '{}')
      }
    },
    mounted() {
      this.fetchOssConfig()
    },
    methods: {
      async fetchOssConfig() {
        try {
          const { data } = await axios.post(`${config.BASE_URL}/shop/api/LaBasicSettingsController.php`, {
            action: 'get_oss',
            store_id: this.userInfo.id
          })
          if (data.data) {
            this.ossForm = {
              aliyun_keyid: data.data.aliyun_keyid || '',
              aliyun_secret: data.data.aliyun_secret || '',
              endpoint: data.data.endpoint || '',
              aliyun_bucket: data.data.aliyun_bucket || ''
            }
          }
        } catch (error) {
          ElMessage.error('获取OSS配置失败')
          console.error('获取OSS配置错误:', error)
        }
      },
  
      async testConnection() {
        if (!this.ossForm.aliyun_keyid || !this.ossForm.aliyun_secret ||
            !this.ossForm.endpoint || !this.ossForm.aliyun_bucket) {
          ElMessage.warning('请填写完整的OSS配置信息')
          return
        }
  
        this.testing = true
        this.testResult = null
        this.testMessage = ''
  
        try {
          const { data } = await axios.post(`${config.BASE_URL}/shop/api/test_oss_connection.php`, {
            ...this.ossForm,
            store_id: this.userInfo.id
          })
  
          this.testResult = data.success
          this.testMessage = data.message || (data.success ? '成功连接到OSS服务' : '连接OSS服务失败')
  
          if (data.success) {
            ElMessage.success('OSS连接测试成功')
          } else {
            ElMessage.error('OSS连接测试失败: ' + (data.message || '未知错误'))
          }
        } catch (error) {
          this.testResult = false
          this.testMessage = error.response?.data?.message || error.message || '测试连接时发生错误'
          ElMessage.error('测试连接失败: ' + this.testMessage)
          console.error('OSS连接测试错误:', error)
        } finally {
          this.testing = false
        }
      },
  
      async submitOssConfig() {
        if (!this.ossForm.aliyun_keyid || !this.ossForm.aliyun_secret ||
            !this.ossForm.endpoint || !this.ossForm.aliyun_bucket) {
          ElMessage.warning('请填写完整的OSS配置信息')
          return
        }
  
        this.loading = true
        try {
          const { data } = await axios.post(
            `${config.BASE_URL}/shop/api/LaBasicSettingsController.php`,
            {
              action: 'update_oss',
              store_id: this.userInfo.id,
              ...this.ossForm
            }
          )
  
          if (data.success) {
            ElMessage.success('OSS配置保存成功')
            this.fetchOssConfig()
          } else {
            ElMessage.error(data.error || '保存失败')
          }
        } catch (error) {
          const errorMsg = error.response?.data?.error || error.message || '服务器错误'
          ElMessage.error(`保存失败：${errorMsg}`)
          console.error('保存OSS配置错误:', error)
        } finally {
          this.loading = false
        }
      },
  
      resetOssConfig() {
        ElMessageBox.confirm('请选择重置方式：', '重置配置', {
          confirmButtonText: '清空表单',
          cancelButtonText: '恢复默认',
          distinguishCancelAndClose: true,
          type: 'warning'
        }).then(() => {
          this.clearForm();
        }).catch((action) => {
          if (action === 'cancel') {
            this.resetToDefault();
          }
        });
      },
  
      clearForm() {
        this.ossForm = {
          aliyun_keyid: '',
          aliyun_secret: '',
          endpoint: '',
          aliyun_bucket: ''
        };
        this.testResult = null;
        this.testMessage = '';
        ElMessage.success('表单已清空');
      },
  
      async resetToDefault() {
        try {
          const { data } = await axios.post(
            `${config.BASE_URL}/shop/api/LaBasicSettingsController.php`,
            {
              action: 'clear_oss',
              store_id: this.userInfo.id
            }
          );
          if (data.success) {
            ElMessage.success('配置已重置为默认值');
            this.fetchOssConfig();
          } else {
            ElMessage.error(data.error || '重置失败');
          }
        } catch (error) {
          ElMessage.error('重置失败: ' + (error.response?.data?.error || error.message));
          console.error('重置OSS配置错误:', error);
        }
      }
    }
  }
  </script>
  
  <style scoped lang="scss">
  .oss-management-page {
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    overflow-x: hidden;
  }
  
  .settings-card {
    background: rgba(18, 14, 33, 0.6);
    backdrop-filter: blur(10px);
    border-radius: 20px;
    border: 1px solid rgba(157, 78, 221, 0.2);
    padding: 24px;
    width: 100%;
    box-sizing: border-box;
  
    @media (max-width: 768px) {
      padding: 16px;
    }
  
    @media (max-width: 576px) {
      padding: 12px;
    }
  }
  
  .page-title {
    font-size: 20px;
    font-weight: 600;
    color: #fff;
    margin-bottom: 24px;
    display: flex;
    align-items: center;
    gap: 10px;
  
    svg {
      color: #c084fc;
    }
  
    @media (max-width: 768px) {
      font-size: 18px;
      margin-bottom: 16px;
    }
  }
  
  .compact-form {
    :deep(.el-form-item__label) {
      font-size: 16px;
      color: #a0a0c0;
      line-height: 40px;
      padding-right: 24px !important;
    }
  
    .form-item-row {
      margin-bottom: 28px;
  
      :deep(.el-form-item__content) {
        flex: 1;
        min-width: 0;
      }
    }
  }
  
  .oss-input {
    width: 100%;
    max-width: 500px;
  }
  
  .oss-tip {
    margin-top: 8px;
    margin-left: 10px;
    color: #7a7a9a;
    font-size: 13px;
    line-height: 1.5;
    display: flex;
    align-items: center;
  
    .tip-icon {
      color: #9d4edd;
      margin-right: 8px;
      font-size: 16px;
    }
  }
  
  .test-btn {
    width: 200px;
    padding: 14px 24px;
  
    .btn-icon {
      margin-right: 8px;
      font-size: 16px;
    }
  }
  
  .test-result {
    margin-top: 12px;
    display: flex;
    align-items: center;
    gap: 12px;
  
    .result-message {
      color: #7a7a9a;
      font-size: 13px;
    }
  }
  
  .form-actions {
    margin-top: 40px;
    text-align: center;
  
    .submit-btn,
    .reset-btn {
      width: 160px;
      padding: 14px 24px;
      font-size: 15px;
      letter-spacing: 0.5px;
  
      .btn-icon {
        margin-right: 8px;
        font-size: 16px;
      }
    }
  }
  
  :deep(.el-input__wrapper) {
    background: rgba(26, 21, 53, 0.8);
    border: 1px solid rgba(157, 78, 221, 0.3);
    border-radius: 10px;
    box-shadow: none;
  
    &:hover {
      border-color: rgba(157, 78, 221, 0.6);
    }
  
    &.is-focus {
      border-color: #9d4edd;
      box-shadow: 0 0 0 2px rgba(157, 78, 221, 0.2);
    }
  
    .el-input__inner {
      color: #fff;
      background: transparent;
  
      &::placeholder {
        color: #5a5a7a;
      }
    }
  }
  
  :deep(.el-button) {
    border-radius: 10px;
    padding: 10px 20px;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-weight: 500;
  }
  
  :deep(.el-button--primary) {
    background: linear-gradient(135deg, #6546b4, #9d4edd);
    border: none;
  
    &:hover {
      transform: translateY(-1px);
    }
  }
  </style>